import { render, staticRenderFns } from "./WorkflowForm.vue?vue&type=template&id=0609d1c7"
import script from "./WorkflowForm.vue?vue&type=script&lang=js"
export * from "./WorkflowForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports